// document.querySelectorAll(".ns-using-solutions__case-card").forEach((item) => {
//     item.addEventListener("mouseover", function (e) {
//         const player = item.querySelector("video");
//         if(player){
//             player.play();
//         }
//     });
// });
// document.querySelectorAll(".ns-using-solutions__case-card").forEach((item) => {
//     item.addEventListener("mouseout", function (e) {
//         const player = item.querySelector("video");
//         if(player){
//             player.pause();
//             player.currentTime = 0;
//         }
//     });
// });
